import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Customer} from '../classes/customer';

@Injectable({
    providedIn: 'root'
})
export class CustomerService {

    constructor(private apiService: ApiService) {
    }

    save(customer: Customer) {
        return this.apiService.postCall$<Customer>(`customers`, customer);
    }

    list() {
        return this.apiService.getCall$<Customer[]>(`customers`);
    }

}
